/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Dashboard_DecentralizationInputs */



/**
* | output |
* | --- |
* | "Decentralization" |
*
* @param {Menu_Dashboard_DecentralizationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const menu_dashboard_decentralization = /** @type {((inputs?: Menu_Dashboard_DecentralizationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Dashboard_DecentralizationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Decentralization")
});